export const initialState = {
	files:{
		courseCode:"",
		courseName:"",
		file:null,
		credits:"",
		timeSpan:{
			start:"",
			end:""
		},
		date:""
	}
}